import ViolationsTabDetails from './ViolationsTabDetails';

export default ViolationsTabDetails;
